import React, { useState } from 'react';
import './BrandAgentJourney.css';

const AVATARS = [
  {
    id: 'aava',
    name: 'Aava',
    role: 'Luova suunnannäyttäjä',
    image: '/brand-agent-aava-v4.png',
    accent: '#cf6b4b',
  },
  {
    id: 'aarni',
    name: 'Aarni',
    role: 'Selkeä strategi',
    image: '/brand-agent-aarni-v4.png',
    accent: '#7f8b68',
  },
  {
    id: 'kide',
    name: 'Kide',
    role: 'AI-maskotti',
    image: '/brand-agent-kide-v4.png',
    accent: '#64bdb6',
  },
];

const TONES = [
  { label: 'Lämmin', line: 'Hei! Autan löytämään juuri sinulle sopivan ratkaisun.' },
  { label: 'Selkeä', line: 'Kerron olennaisen ja ohjaan sinut suoraan eteenpäin.' },
  { label: 'Rohkea', line: 'Tehdään brändistäsi sellainen, joka jää mieleen.' },
];

const STEPS = [
  { label: 'Valitse', title: 'Valitse brändillesi kasvot' },
  { label: 'Näy', title: 'Sama persoona näkyy kaikkialla' },
  { label: 'Tulos', title: 'Kiinnostus muuttuu yhteydenotoksi' },
];

function Character({ avatar, className = '' }) {
  return (
    <div
      className={'bjs-character ' + className}
      style={{ backgroundImage: 'url(' + avatar.image + ')' }}
      role="img"
      aria-label={avatar.name + ', ' + avatar.role}
    />
  );
}

export default function BrandAgentJourney() {
  const [avatarIndex, setAvatarIndex] = useState(0);
  const [toneIndex, setToneIndex] = useState(0);
  const [stage, setStage] = useState(0);

  const avatar = AVATARS[avatarIndex];
  const tone = TONES[toneIndex];


  const chooseStage = (index) => {
    setStage(index);
  };

  const startDemo = () => {
    setStage(1);
  };

  return (
    <section
      className={'brand-journey bjs-stage-' + stage}
      style={{ '--bjs-accent': avatar.accent }}
      aria-labelledby="brand-journey-title"
    >
      <div className="bjs-shell">
        <header className="bjs-header">
          <div>
            <span>Brändiagentti käytännössä</span>
            <h2 id="brand-journey-title">Näin se toimii</h2>
          </div>
          <span className="bjs-duration">3 vaihetta</span>
        </header>

        <nav className="bjs-steps" aria-label="Brändiagentin vaiheet">
          {STEPS.map((item, index) => (
            <button
              key={item.label}
              type="button"
              className={index === stage ? 'is-active' : index < stage ? 'is-done' : ''}
              onClick={() => chooseStage(index)}
              aria-current={index === stage ? 'step' : undefined}
            >
              <i>{index < stage ? '✓' : index + 1}</i>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="bjs-body">
          <div className="bjs-copy">
            <span className="bjs-kicker">{String(stage + 1).padStart(2, '0')} / 03</span>
            <h3>{STEPS[stage].title}</h3>

            {stage === 0 && (
              <>
                <p>Valitse yrityksesi tyyliin sopiva hahmo ja äänensävy.</p>
                <div className="bjs-avatar-list" aria-label="Valitse hahmo">
                  {AVATARS.map((item, index) => (
                    <button
                      key={item.id}
                      type="button"
                      className={index === avatarIndex ? 'is-selected' : ''}
                      onClick={() => setAvatarIndex(index)}
                      aria-pressed={index === avatarIndex}
                    >
                      <Character avatar={item} />
                      <span><strong>{item.name}</strong><small>{item.role}</small></span>
                    </button>
                  ))}
                </div>
                <div className="bjs-tones" aria-label="Valitse äänensävy">
                  {TONES.map((item, index) => (
                    <button
                      key={item.label}
                      type="button"
                      className={index === toneIndex ? 'is-selected' : ''}
                      onClick={() => setToneIndex(index)}
                      aria-pressed={index === toneIndex}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              </>
            )}

            {stage === 1 && (
              <p>Yksi tunnistettava hahmo puhuu samalla äänellä somessa ja verkkosivullasi.</p>
            )}

            {stage === 2 && (
              <p>Kun kohtaaminen tuntuu luontevalta, asiakkaan on helpompi ottaa yhteyttä.</p>
            )}
          </div>

          <div className="bjs-visual">
            <div className="bjs-glow" aria-hidden="true" />
            <Character avatar={avatar} />

            {stage === 0 && (
              <div className="bjs-bubble">
                <small>{avatar.name}</small>
                <p>{tone.line}</p>
              </div>
            )}

            {stage === 1 && (
              <div className="bjs-channels">
                <article>
                  <i>◎</i>
                  <span><small>Sosiaalinen media</small><strong>Sama ilme ja ääni</strong></span>
                  <b>Julkaistu</b>
                </article>
                <article>
                  <i>↗</i>
                  <span><small>Verkkosivu</small><strong>Auttaa kävijää</strong></span>
                  <b>Paikalla</b>
                </article>
              </div>
            )}

            {stage === 2 && (
              <article className="bjs-contact">
                <span className="bjs-contact-icon">↗</span>
                <small>JUURI NYT · VERKKOSIVULTA</small>
                <h4>Uusi yhteydenotto</h4>
                <p>“Hei! Haluaisin kuulla lisää brändiagentista.”</p>
                <div><i>EL</i><span><strong>Ella Laine</strong><small>Potentiaalinen asiakas</small></span><b>+1</b></div>
              </article>
            )}
          </div>
        </div>

        <footer className="bjs-footer">
          {stage === 0 && (
            <button className="bjs-primary" type="button" onClick={startDemo}>
              Katso, miten {avatar.name} toimii <span>→</span>
            </button>
          )}
          {stage === 1 && (
            <button className="bjs-primary" type="button" onClick={() => chooseStage(2)}>
              Näytä lopputulos <span>→</span>
            </button>
          )}
          {stage === 2 && (
            <button className="bjs-secondary" type="button" onClick={() => chooseStage(0)}>
              Kokeile toista hahmoa
            </button>
          )}
        </footer>
      </div>
    </section>
  );
}
